import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/ru'  // without this line it didn't work

import { sendRequest, triggerEvent, eventOn } from './helpers/global.js';
import Storage from './helpers/Storage.js';
import dishesConfig from './config/dishes.js';
import usersConfig from './config/users.js';
import paymentsConfig from './config/payments.js';
//import NotificationsController from './helpers/NotificationsController';

import LoginView from './components/LoginView.js';
import ForgotPasswordView from './components/ForgotPasswordView.js';
import ResetPasswordView from './components/ResetPasswordView.js';
import HeaderView from './components/HeaderView.js';
import LoadIndicator from './components/LoadIndicator';
import ConfirmationPopup from './components/common/ConfirmationPopup';
import ContentPopup from './components/common/ContentPopup';
import NotificationPopup from './components/common/NotificationPopup';
import Snackbar from './components/common/Snackbar';

import SettingsView from './components/SettingsView.js';
import WeekView from './components/WeekView.js';
import ObjectListView from './components/ObjectListView.js';
import ObjectEditView from './components/ObjectEditView.js';

import ReportView from './components/ReportView.js';

moment.locale('ru');

const mapStoreToProps = (store) => ({
  user: store.data.user,
});

const AdminRoute = ({ component: Component, location, path, user, ...rest }) => (
  <Route location={location} path={path} render={(props) => {
    if (!user) return <Redirect to='/login'/>
    if (!user.admin) return <Redirect to='/current'/>
    return <Component {...props} {...rest}/>
  }}/>
)

const UserRoute = ({ component: Component, location, path, user, ...rest }) => (
  <Route location={location} path={path} render={(props) => {
    if (!user) return <Redirect to='/login'/>
    return <Component {...props} {...rest}/>
  }}/>
)

const LoginRoute = ({ component: Component, location, path, user, ...rest }) => (
  <Route location={location} path={path} render={(props) => {
    if (user) return <Redirect to='/current'/>
    return <Component {...props} {...rest}/>
  }}/>
)

class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showLoadIndicator: false,
    };
    this.loadCount = 0;

    eventOn('addLoad', this.addLoad);
    eventOn('removeLoad', this.removeLoad);
    eventOn('unauthorized', this.onUnauthorized);
    eventOn('forbidden', this.onForbidden);

    eventOn('resize', (e) => {
      Storage.setSetup('isMobile', window.innerWidth <= 768);
    }, window);
    Storage.setSetup('isMobile', window.innerWidth <= 768);
  }

  componentDidUpdate = (prevProps, prevState) => {
  }

  addLoad = () => {
    this.loadCount++;
    if (this.state.showLoadIndicator !== (this.loadCount > 0)) {
      this.setState({showLoadIndicator: this.loadCount > 0});
    }
  }

  removeLoad = () => {
    this.loadCount--;
    if (this.state.showLoadIndicator !== (this.loadCount > 0)) {
      this.setState({showLoadIndicator: this.loadCount > 0});
    }
  }

  onLogout = (unauthorized) => {
    if (!unauthorized) {
      sendRequest({
        type: 'POST',
        method: 'me/logout',
      });
    }
    Storage.setData('user', null);
    localStorage.removeItem('launch-planner-client:token');
  }

  onUnauthorized = () => {
    triggerEvent('showSnackbar', [{text: 'Пожалуйста перезайдите в систему', type: 'error'}]);
    this.onLogout(true);
  }

  onForbidden = () => {
    triggerEvent('showSnackbar', [{text: 'Недостаточно прав', type: 'error'}]);
    this.props.history.goBack();
  }

  componentDidMount = () => {
    if (this.props.user) {
      sendRequest({
        method: 'me/',
        type: 'GET',
        success: (data) => {
          Storage.setData('user', data);
        },
        error: (data) => {
        }
      });
    }
  }

  render = () => {
    const user = this.props.user;
    const hideUI = false;
    return (
      <div>
        {hideUI ? null : <HeaderView
          onLogout={this.onLogout}
        />}
        <div className={classnames({
          'adminContent': true,
          'customScrollBar': true,
          'showUI': !hideUI,
        })}>
          <Switch>
            <AdminRoute user={user} path='/report' component={ReportView}/>

            <AdminRoute user={user} path='/users/:id' config={usersConfig} component={ObjectEditView}/>
            <AdminRoute user={user} path='/users' config={usersConfig} component={ObjectListView}/>

            <AdminRoute user={user} path='/dishes/:id' config={dishesConfig} component={ObjectEditView}/>
            <AdminRoute user={user} path='/dishes' config={dishesConfig} component={ObjectListView}/>

            <UserRoute user={user} path='/payments/:id' config={paymentsConfig} component={ObjectEditView}/>
            <UserRoute user={user} path='/payments' config={paymentsConfig} component={ObjectListView}/>

            <UserRoute user={user} path='/next' component={WeekView} week='next'/>
            <UserRoute user={user} path='/current' component={WeekView} week='current'/>
            <UserRoute user={user} path='/settings' component={SettingsView}/>

            <LoginRoute user={user} path='/reset_password/:token' component={ResetPasswordView}/>
            <LoginRoute user={user} path='/forgot_password' component={ForgotPasswordView}/>
            <LoginRoute user={user} path='/' component={LoginView}/>
          </Switch>
        </div>

        <LoadIndicator show={this.state.showLoadIndicator}/>
        {/*<NotificationsController/>*/}
        <ConfirmationPopup global/>
        <ContentPopup global/>
        <NotificationPopup/>
        <Snackbar/>
      </div>
    )
  }
}

export default connect(mapStoreToProps)(withRouter(App));
